import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { AppRecoveryBoundary, renderBootstrapRecovery } from "./AppRecoveryBoundary";
import { initializeNativeAuthenticationState } from "./api";
import { initializeNativeRuntime } from "./nativeRuntime";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
    mutations: { retry: false },
  },
});

async function bootstrap(root: HTMLElement): Promise<void> {
  await initializeNativeRuntime().catch(() => undefined);
  // Native storage reads are bounded. If a Keychain/Keystore bridge hangs,
  // render the login shell in fail-closed mode instead of blocking bootstrap.
  await initializeNativeAuthenticationState();
  createRoot(root).render(
    <StrictMode>
      <AppRecoveryBoundary>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </AppRecoveryBoundary>
    </StrictMode>,
  );
}

const root = document.getElementById("root");
if (root) {
  void bootstrap(root).catch(() => renderBootstrapRecovery(root));
}
